import classNames from 'classnames';
import React from 'react';
import OrderQuotaBanner from 'src/components/Billing/OrderQuotaBanner';
import CartBar from 'src/components/POS/CartBar';
import CurrentOrder from 'src/components/POS/CurrentOrder';
import Menu from 'src/components/POS/Menu';
import MenuItems from 'src/components/POS/MenuItems';
import MobileTabs from 'src/components/POS/MobileTabs';
import RecentOrders from 'src/components/POS/RecentOrders';
import { usePOSStore } from 'src/states/pos';

interface POSProps {}

const POS = React.memo((_: POSProps) => {
  const expandingRecentOrders = usePOSStore((state) => state.expandingRecentOrders);

  const pageClass = classNames({
    'pos-page': true,
    // Mobile only: the tab bar shows one pane at a time, so the menu grid is hidden
    // while recent orders are showing.
    'pos-page--orders-tab': expandingRecentOrders,
  });

  return (
    <div className={pageClass}>
      <OrderQuotaBanner />
      <MobileTabs />
      <div className="pos-page__main-content">
        <div className={'pos-items'}>
          <div className={'pos-menu-container'}>
            <Menu />
            <MenuItems />
          </div>
          <hr />
          <RecentOrders />
        </div>
        <CurrentOrder />
      </div>
      <CartBar />
    </div>
  );
});

export default POS;
